import { connect } from "react-redux";
import { getCatalogServicesSubCategoryRequest } from "store/actions/cos.actions";
import {
  participantQuickSnapshotCall,
  participantSettingUpdate,
  participantSettingUpdateCall,
} from "store/actions/participant.actions";
import { getSPWorkerRequest } from "store/actions/sp.actions";
import { getServiceCatalogStates } from "store/selector/cos.selector";
import {
  getLoading,
  getParticipantQuickSnapshot,
  getQuickSnapshotLoading,
  getSelectedParticipant,
  getSettingLoading,
} from "store/selector/participant.selector";
import {
  getSpWorkers,
  getSpSupportCoordinators, getSpAlliedHealthWorkers,
} from "store/selector/sp.selector";
import Setting from "./Settings";

const toPlainObject = (value) => {
  if (!value) return value;
  if (typeof value.toJS === "function") return value.toJS();
  return value;
};

const mapDispatchToProps = {
  fetchSettingsData: participantQuickSnapshotCall,
  fetchWorkers: getSPWorkerRequest,
  updateSettingRequest: participantSettingUpdateCall,
  beginParticipantSettingUpdate: () => participantSettingUpdate.pending,
  syncParticipantSettings: participantSettingUpdate.success,
  failParticipantSettingUpdate: participantSettingUpdate.error,
  getCatalogServicesSubCategory: getCatalogServicesSubCategoryRequest,
};

const mapStateToProps = (state) => {
  const selectedParticipant = getSelectedParticipant(state);
  const quickSnapshot = toPlainObject(getParticipantQuickSnapshot(state));
  const normalizedParticipant = selectedParticipant?.data
    ? selectedParticipant.data
    : selectedParticipant;
  const plainParticipant = toPlainObject(normalizedParticipant);
  const settingData = plainParticipant
    ? { ...(quickSnapshot || {}), ...plainParticipant }
    : quickSnapshot;
  const workersList = getSpWorkers(state);
  const supportCoordinatorsList = getSpSupportCoordinators(state);
  const alliedHealthWorkersList = getSpAlliedHealthWorkers(state);
  const settingLoading = getQuickSnapshotLoading(state);
  const isLoading = getSettingLoading(state);
  const catalogStates = getServiceCatalogStates(state);

  return {
    settingData,
    workersList,
    isLoading,
    settingLoading,
    supportCoordinatorsList,
    alliedHealthWorkersList,
    catalogStates,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Setting);
